import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {CardElement, ElementsConsumer} from "@stripe/react-stripe-js";
import BackButton from './BackButton';

class SubscribeWithPayment extends Component {

  state = {
    errorMessage: '',
    subscription: this.props.subscriptionStatus,
    stripe: this.props.stripe,
    elements: this.props.elements,
    name: 'Cardholder\'s name',
    paymentIntent: null
  };

  // When the subscribe-form is submitted we do a few things:
  //
  //   1. Tokenize the payment method
  //   2. Create the subscription
  //   3. Handle any next actions like 3D Secure that are required for SCA.
  handleSubmit = async (e) => {
    e.preventDefault();

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = this.state.elements.getElement(CardElement);

    // Use card Element to tokenize payment details
    let {error, paymentIntent} = await this.state.stripe.confirmCardPayment(this.state.subscription.clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: this.state.name,
        }
      }
    });

    if (error) {
      // show error and collect new card details.
      this.setState({
        errorMessage: error.message
      });
      return;
    } else {
      this.setState({
        paymentIntent: paymentIntent
      });
      await this.props.resetSubscription();
    }
  }

  render() {
    const {errorMessage, paymentIntent, name, stripe, elements} = this.state;

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return '';
    }

    if (paymentIntent && paymentIntent.status === 'succeeded') {
      return <Redirect to={{pathname: '/subscriptionStatus'}}/>
    }

    const cardElementOptions = {
      style: {
        base: {
          iconColor: '#64748b',
          color: '#0f172a',
          fontWeight: '500',
          fontFamily: 'Inter, Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          ':-webkit-autofill': {
            color: '#0f172a',
          },
          '::placeholder': {
            color: '#94a3b8',
          },
        },
        invalid: {
          iconColor: '#c02b3c',
          color: '#c02b3c',
        },
      }
    }

    return (
      <div className="app">
        {this.props.navbar}
        <div className="page-container">
          <BackButton/>
          <span className="page-eyebrow">Subscription</span>
          <h2 className="page-title">Payment details</h2>

          {errorMessage &&
            <div className="alert callout callout-warning">{errorMessage}</div>
          }

          {process.env.REACT_APP_SOREAL_ENV === "dev" &&
            <div className="alert callout callout-info">
              Try the successful test card: <b>4242 4242 4242 4242</b>
            </div>
          }

          <form onSubmit={this.handleSubmit} className="surface-card surface-card-padded">
            <label className="field-label" htmlFor="name">Full name</label>
            <input
              className="text-input"
              type="text"
              id="name"
              value={name}
              onChange={(e) => this.setState({name: e.target.value})}
              style={{marginBottom: 18}}
            />

            <label className="field-label">Card details</label>
            <div className="card-element-shell" style={{marginBottom: 22}}>
              <CardElement options={cardElementOptions}/>
            </div>

            <button className="btn-brand btn-brand-primary btn-block">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    );
  }
}

const SubscribeWithPaymentWithStripe = (props) => (
  <ElementsConsumer>
    {({stripe, elements}) => (
      <SubscribeWithPayment
        stripe={stripe}
        elements={elements}
        {...props}
      />
    )}
  </ElementsConsumer>
);

export default withRouter(SubscribeWithPaymentWithStripe);
